<div class="{{ size }}">
  <img src="assets/images/logo-horizontal.png" class="img-fluid">
</div>


